import { render, staticRenderFns } from "./UserPermissions.vue?vue&type=template&id=1c7a555e&scoped=true"
import script from "./UserPermissions.vue?vue&type=script&lang=js"
export * from "./UserPermissions.vue?vue&type=script&lang=js"
import style0 from "./UserPermissions.vue?vue&type=style&index=0&id=1c7a555e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7a555e",
  null
  
)

export default component.exports